export const languages = ["ar", "fr", "en"];

export const profileRedirectMap = {
  "/tlFDfeL0VJfBY0IBsb": "/sla2uiQCUStm01sA2J",
  "/ccxmj73VnmOtGRskgl": "/lPATOHX77eIfihQZy9",
  "/ZMHtQYmtmI5cnysOwY": "/4fAC3rOSx5L5JsokCA",
  "/TqmXte1EJoBhcOpjag": "/LYDBhZHy2ryCEB2l1F",
  "/jqgBQl1r3cBIhnqti7": "/tb9Gj0qLfx7j8eqfQL",
  "/m8Cy10AzC2VhLUiSUs": "/zGQ2OZwDcWZBLDZ4Cw",
  "/selD3YLZzKCJKJ9yuv": "/sysEaBI8Zlvl8WuDCb",
  "/Y8hi0Bg6yhbYxNXVBG": "/1XSFg5KB700pogqkI1",
  "/e0XFFK2vywqv0zZMew": "/LbwjWVQvxqX9UcPmGQ",
  "/FG22pRMsE3YzRs1W1": "/VTc940BuQM2CDbrtAO",
  "/GQfawnHD92Dr3DRCp7": "/564Aej0ofZX4TsjzQH",
  "/MYNsuSlSQV5BoxiUn3": "/MYNsuSlSQV5BoxiUn311",
};
